import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "review-box-header" }
const _hoisted_2 = { class: "review-box-header__info" }
const _hoisted_3 = { class: "review-box-header__text-content" }
const _hoisted_4 = { class: "review-box-header__title" }
const _hoisted_5 = { class: "review-box-header__text" }

import { computed } from 'vue';

import { RATING_MAX_VALUE } from '@global-js/constants';
import ReviewerInfo from './ReviewerInfo.vue';
import { ReviewType } from '@/interfaces/review-types';
import RatingBox from './RatingBox.vue';
import { numberFormat } from '@/js/utils/numberUtils';

interface Props {
	review: ReviewType
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewBoxHeader',
  props: {
    review: {}
  },
  setup(__props: any) {

const props = __props;

const rating = computed(() => `${numberFormat(props.review.RatingOverallValue)}/${RATING_MAX_VALUE}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReviewerInfo, { review: _ctx.review }, null, 8 /* PROPS */, ["review"]),
      _createVNode(RatingBox, {
        rating: rating.value,
        theme: "normal"
      }, null, 8 /* PROPS */, ["rating"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.review.Headline), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.review.Conclusion), 1 /* TEXT */)
    ])
  ]))
}
}

})